import './Import.css';
import { Button } from 'primereact/button';
import { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { ProgressBar } from 'primereact/progressbar';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { setShowImport } from '../../features/toolbarSlice';
import { selectServices, setServices, setTableLayer, setLayerGroups, setImportLayerGroup } from '../../features/layerSlice';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';
import axios from 'axios';
import { setImportedFile, setImportedFileVisibility } from '../../features/importSlice';
import KML from 'ol/format/KML';
import { useTranslation } from 'react-i18next';

export default function Import() {
    const displayImport = useAppSelector(state => state.toolbarState.showImport);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const toast = useRef<any>();
    const [totalSize, setTotalSize] = useState(0);
    const getServices = useAppSelector(selectServices);
    const fileUploadRef = useRef<any>(null);
    const token = useAppSelector(state => state.authState.token);
    const offlineLayerGroup: any = []
    const [files, setFiles] = useState<any>([])
    const onHide = async () => {
        dispatch(setShowImport(false));
    }

    const onClickImport = async () => {

        const kmlFileExtension = ['.kml', '.kmz'];

        const fileExtension = files[0].name.split('.').pop().toLowerCase();

        if (kmlFileExtension.includes(`.${fileExtension}`)) {
            const offlineLayerGroup = {
                key: 'cevrimdisi',
                label: "Çevrimdışı",
                children: [{
                    key: `cevrimdisi-${files[0].name}`,
                    label: files[0].name,
                    data: files[0],
                }],
            }
            dispatch(setImportLayerGroup(offlineLayerGroup))
            dispatch(setImportedFile(files))
            dispatch(setImportedFileVisibility(true))
            onHide()
        }
        else {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Lütfen bir KML dosyası seçin.' });
        }
    }

    const headerTemplate = (options: any) => {
        const { className, chooseButton, uploadButton, cancelButton } = options;
        const value = totalSize / 10000;
        const formatedValue = fileUploadRef && fileUploadRef.current ? fileUploadRef.current.formatSize(totalSize) : '0 B';
        return (
            <div className={className} style={{ backgroundColor: 'transparent', display: 'flex', alignItems: 'center' }}>
                {chooseButton}
                {cancelButton}
                <ProgressBar value={value} displayValueTemplate={() => `${formatedValue} / 5 MB`} style={{ width: '300px', height: '20px', marginLeft: 'auto' }}></ProgressBar>
            </div>
        );
    }

    const onTemplateSelect = (e: any) => {
        const files = [...e.files]

        files?.map((file: any) => {
            file.text().then((kml: any) => {
                const kmlReader = new KML()
                const features: any = kmlReader.readFeatures(kml);

                if (features.length > 0) {
                    setFiles(files)
                }
                else {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Lütfen doğru bir KML dosyası seçin.' });
                }
            });
        })
    }

    return (
        <div className='import-container'>
            <Toast ref={toast}></Toast>
            <Dialog header="İçe Aktar" style={{ minWidth: '30vw' }} visible={true} onHide={() => dispatch(setShowImport(!displayImport))}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <div style={{ marginBottom: '20px', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div></div>
                        <FileUpload
                            ref={fileUploadRef}
                            headerTemplate={headerTemplate}
                            accept=".kml,.kmz"
                            invalidFileSizeMessageSummary='Yüksek dosya boyutu. '
                            invalidFileSizeMessageDetail='Yüklediğiniz dosyanın boyutu en fazla 50 MB olabilir.'
                            maxFileSize={52428800}
                            onSelect={onTemplateSelect}
                            onUpload={onClickImport}
                            chooseLabel={`${t("BUTTON.Choose")}`}
                            cancelLabel={`${t("BUTTON.Cancel")}`}
                        />
                    </div>
                    <Button
                        disabled={true ? files.length === 0 : false}
                        onClick={() => onClickImport()}
                        label="İçe Aktar"></Button>
                </div>
            </Dialog>
        </div>
    )
}
